// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.reason-message[data-v-935d0138] {\r\n  color: var(--carbon-600);\n}\r\n", ""]);
// Exports
module.exports = exports;
